import moment from 'moment';

type FieldItem = {
    id: string;
    type: 'single' | 'multiple' | 'text';
    value: number | number[] | string;
    overwrite: boolean;
};

type SubscribeItemType = {
    contactListId: string[];
    fields: FieldItem[];
};

const SUBSCRIBE_PARAMS: { [key: string]: SubscribeItemType } = {
    eu: {
        contactListId: ['1881888806'],
        fields: [
            {
                id: '4427',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '7596',
                type: 'multiple',
                value: [47],
                overwrite: false,
            },
            {
                id: '12888',
                type: 'text',
                value: moment(new Date()).format('YYYY-MM-DD'), // 2025-05-06
                overwrite: false,
            },
            {
                id: '9690',
                type: 'multiple',
                value: [12],
                overwrite: false,
            },
        ],
    },
    uk: {
        contactListId: ['407065862'],
        fields: [
            {
                id: '4430',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '7596',
                type: 'multiple',
                value: [47],
                overwrite: false,
            },
            {
                id: '9690',
                type: 'multiple',
                value: [12],
                overwrite: false,
            },
            {
                id: '12888',
                type: 'text',
                value: moment(new Date()).format('YYYY-MM-DD'), // 2025-05-06
                overwrite: false,
            },
        ],
    },
    de: {
        contactListId: ['546912860'],
        fields: [
            {
                id: '4425',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '7596',
                type: 'multiple',
                value: [47],
                overwrite: false,
            },
            {
                id: '9690',
                type: 'multiple',
                value: [12],
                overwrite: false,
            },
            {
                id: '12888',
                type: 'text',
                value: moment(new Date()).format('YYYY-MM-DD'), // 2025-05-06
                overwrite: false,
            },
        ],
    },
    fr: {
        contactListId: ['692013039'],
        fields: [
            {
                id: '4428',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '7596',
                type: 'multiple',
                value: [47],
                overwrite: false,
            },
            {
                id: '9690',
                type: 'multiple',
                value: [12],
                overwrite: false,
            },
        ],
    },
    it: {
        contactListId: ['1546541844'],
        fields: [
            {
                id: '4429',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '7596',
                type: 'multiple',
                value: [47],
                overwrite: false,
            },
            {
                id: '9690',
                type: 'multiple',
                value: [12],
                overwrite: false,
            },
        ],
    },
    es: {
        contactListId: ['1870490587'],
        fields: [
            {
                id: '4426',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '7596',
                type: 'multiple',
                value: [47],
                overwrite: false,
            },
            {
                id: '9690',
                type: 'multiple',
                value: [12],
                overwrite: false,
            },
        ],
    },
};

/**
 * Retrieves subscription parameters based on the specified locale.
 *
 * @param locale - The locale for which to retrieve subscription parameters.
 * @returns The subscription parameters corresponding to the given locale.
 */
export const getSubscribeParams = (locale: string) => {
    return SUBSCRIBE_PARAMS[locale] || SUBSCRIBE_PARAMS['eu'];
};
